import { NgModule } from '@angular/core';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzImageModule } from 'ng-zorro-antd/image';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzListModule } from 'ng-zorro-antd/list';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzNotificationModule } from 'ng-zorro-antd/notification';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzStatisticModule } from 'ng-zorro-antd/statistic';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';

import { NZ_ICONS, NzIconModule } from 'ng-zorro-antd/icon';

import {
    AppstoreFill,
    BarChartOutline,
    CopyOutline,
    DashboardOutline,
    DownloadOutline,
    FileExcelOutline,
    FormOutline,
    FullscreenExitOutline,
    FullscreenOutline,
    LineChartOutline,
    MenuFoldOutline,
    MenuUnfoldOutline,
    SyncOutline,
    TableOutline,
    WarningOutline,
} from '@ant-design/icons-angular/icons';

const icons = [
    AppstoreFill,
    BarChartOutline,
    CopyOutline,
    DashboardOutline,
    DownloadOutline,
    FileExcelOutline,
    FormOutline,
    FullscreenOutline,
    FullscreenExitOutline,
    LineChartOutline,
    MenuFoldOutline,
    MenuUnfoldOutline,
    SyncOutline,
    TableOutline,
    WarningOutline,
];

@NgModule({
    imports: [NzIconModule, NzImageModule],
    exports: [
        NzAlertModule,
        NzButtonModule,
        NzCheckboxModule,
        NzCollapseModule,
        NzDatePickerModule,
        NzDividerModule,
        NzDropDownModule,
        NzGridModule,
        NzIconModule,
        NzInputModule,
        NzInputNumberModule,
        NzLayoutModule,
        NzListModule,
        NzMenuModule,
        NzModalModule,
        NzNotificationModule,
        NzRadioModule,
        NzSelectModule,
        NzSkeletonModule,
        NzStatisticModule,
        NzSpinModule,
        NzTableModule,
        NzToolTipModule,
    ],
    providers: [{ provide: NZ_ICONS, useValue: icons }],
})
export class NgZorroAntdModule {}
